import { PrintTypeLong } from './print-type';

export enum LineType {
    primary = 'PrimaryLine',
    secondary = 'SecondaryLine',
    product = 'ProductLine',
    sub = 'SubLine',
}

export interface OfferPrintOptions {
    printType: PrintTypeLong;
    printLocale: string;
    textMap: {};
    options: {
        draft: boolean;
        printItemPrices: boolean;
        printDiscounts: boolean;
        printLogo: boolean;
    };
}

export type OfferTexts = { [key: string]: string };

export interface OfferCondition {
    type: string;
    value: number;
    condValue?: number;
    currency?: string;
}

export interface OfferItem {
    itemNumber?: number;
    material: string;
    quantity: number;
    group?: string;
    conditions?: OfferCondition[];
    itemCategory?: string;
    grossPrice?: number;
    optional: boolean;
    texts?: OfferTexts;
}

export interface QuoteAssignment {
    variableName: string;
    valueName?: string;
    valueText?: string;
    isUserAssignment?: boolean;
    isDefault?: boolean;
}

export interface QuotationQuoteLine {
    type: LineType;
    material: string;
    assignments: QuoteAssignment[];
}

export type QuoteStatus = 'New' | 'Quoted';

export interface OfferExtraData {
    status: QuoteStatus;
    primarySchemes: string;
    secondarySchemes: string;
    energyLabelHash: string;
    externalApp?: string;
    lines: QuotationQuoteLine[];
}

export interface Offer {
    documentNumber?: string;
    customerNumber: string;
    voucherId: string;
    customerPurchaseNumber: string;
    currency: string;
    submissionNumber: string; // COLLECT_NO
    salesforceRequestId?: string; // QUOTATION_REQUEST_ID
    items: OfferItem[];
    printOptions: OfferPrintOptions;
    extraData?: OfferExtraData;
}
